import { useLocation, useParams } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import "./blogDetail.scss";
import { toast } from "react-toastify";
import { getBlogByURL } from "../../services/getBlogs";
import { useEffect, useState } from "react";
import { dateFormat } from "../dashboard/dateFormat";
import BlogForm from "./components/BlogForm";
import { Helmet } from "react-helmet";
import { ImageLink } from "../../constants";

const BlogsDetail = () => {
  const location = useLocation();
  const locationData= location?.state?.data;
  const { slug } = useParams();
  const [data, setData] = useState(null);
console.log("locationData", locationData);
  const fetchData = async () => {
    try {
      const response = await getBlogByURL(slug);
      setData(response?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [slug]);

  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Blogs" },
    { label: data?.title || "" },
  ];

  const blogUrl = `${window.location.origin}/blogs/${slug}`;
  const imageUrl = locationData?.coverImage ? ImageLink(locationData.coverImage) : "";

  return (
    <>
      {locationData && (
        <Helmet>
          <title>{locationData.title}</title>
          <meta property="og:title" content={locationData.title} />
          <meta property="og:image" content={imageUrl} />
          <meta property="og:url" content={blogUrl} />
          <meta property="og:type" content="article" />
          <meta
            property="article:published_time"
            content={new Date(locationData?.createdAt).toISOString()}
          />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={locationData.title} />
          <meta name="twitter:description" content={locationData.shortDescription || locationData.title} />
          <meta name="twitter:image" content={imageUrl} />
        </Helmet>
      )}

      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>

      <div className="blogs-detail ">
        <div className="container baner-container">
          <h1>{data?.title}</h1>
           <div className="d-flex align-items-center gap-3">
  <span>DoubtQ Blogs</span>
  {
    data?.updatedAt && (
      <span>{dateFormat(data?.updatedAt)}</span>
    )
  }
</div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="row">
          <div className="col-sm-8">
            {data?.description && (
              <div
                dangerouslySetInnerHTML={{ __html: data?.description }}
              ></div>
            )}
          </div>

          <div className="col-sm-4 d-flex flex-column align-items-end gap-4 p-4">
            <BlogForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsDetail;